import { useState } from 'react';
import { faqList } from '@/mocks/wuyi';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          kicker="吃瓜指南 · FAQ"
          title="常见"
          accent="问题"
          desc="关于热点收录、榜单排名与投稿方式，这里一次性帮你解答清楚。"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqList.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3 font-medium text-foreground-900">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-heading text-sm ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      Q
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-lg transition-transform ${isOpen ? 'rotate-180 text-primary-500' : 'text-foreground-400'}`}
                    style={{ transitionDuration: '300ms' }}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[58px] text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-foreground-500">
          没找到答案？欢迎通过下方
          <button
            type="button"
            onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
            className="mx-1 cursor-pointer font-medium text-accent-600 underline underline-offset-4 hover:text-accent-700"
          >
            联系方式
          </button>
          与我们聊聊。
        </p>
      </div>
    </section>
  );
}